import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../context/AuthContext';
import { FaTimes, FaPlus, FaEdit, FaTrash } from 'react-icons/fa';

const ICON_OPTIONS = [
  { value: 'FaCheckCircle', label: 'Onay (Check)' },
  { value: 'FaClock', label: 'Saat (Clock)' },
  { value: 'FaSmile', label: 'Mutlu (Smile)' },
  { value: 'FaUsers', label: 'Kullanicilar (Users)' },
  { value: 'FaBuilding', label: 'Bina (Building)' },
  { value: 'FaTools', label: 'Aletler (Tools)' },
  { value: 'FaStar', label: 'Yildiz (Star)' },
  { value: 'FaAward', label: 'Odul (Award)' },
  { value: 'FaHandshake', label: 'Tokalaşma (Handshake)' },
  { value: 'FaProjectDiagram', label: 'Proje (Project)' },
  { value: 'FaHardHat', label: 'Baret (Hard Hat)' },
  { value: 'FaThumbsUp', label: 'Begeni (Thumbs Up)' },
];

export default function AdminCounters() {
  useAuth();
  const [counters, setCounters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ icon: 'FaCheckCircle', value: 0, suffix: '+', label: '', sort_order: 0, is_active: true });

  useEffect(() => { fetchCounters(); }, []);

  const fetchCounters = async () => {
    try {
      const res = await api.get('/counters/all');
      setCounters(Array.isArray(res.data) ? res.data : []);
    } catch { toast.error('Veriler yüklenemedi'); }
    finally { setLoading(false); }
  };

  const openModal = (counter = null) => {
    if (counter) {
      setEditing(counter);
      setForm({
        icon: counter.icon || 'FaCheckCircle',
        value: counter.value || 0,
        suffix: counter.suffix || '+',
        label: counter.label || '',
        sort_order: counter.sort_order || 0,
        is_active: counter.is_active !== false,
      });
    } else {
      setEditing(null);
      setForm({ icon: 'FaCheckCircle', value: 0, suffix: '+', label: '', sort_order: counters.length + 1, is_active: true });
    }
    setModalOpen(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.label) return toast.error('Etiket zorunlu');
    try {
      if (editing) {
        await api.put(`/counters/${editing.id}`, form);
        toast.success('Güncellendi');
      } else {
        await api.post('/counters', form);
        toast.success('Eklendi');
      }
      setModalOpen(false);
      fetchCounters();
    } catch { toast.error('Hata oluştu'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Silmek istediğinize emin misiniz?')) return;
    try {
      await api.delete(`/counters/${id}`);
      toast.success('Silindi');
      fetchCounters();
    } catch { toast.error('Silinemedi'); }
  };

  if (loading) return <div className="admin-loading">Yükleniyor...</div>;

  return (
    <div>
      <div className="admin-card">
        <div className="admin-card-header">
          <h2>Rakamlarla Biz</h2>
          <button className="btn btn-primary" onClick={() => openModal()}>
            <FaPlus /> Yeni Ekle
          </button>
        </div>

        {counters.length === 0 ? (
          <div className="empty-state"><p>Henüz sayaç eklenmemiş</p></div>
        ) : (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Sıra</th>
                <th>İkon</th>
                <th>Değer</th>
                <th>Sonek</th>
                <th>Etiket</th>
                <th>Durum</th>
                <th>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {counters.map(c => (
                <tr key={c.id}>
                  <td>{c.sort_order}</td>
                  <td>{c.icon}</td>
                  <td><strong>{c.value}</strong></td>
                  <td>{c.suffix}</td>
                  <td>{c.label}</td>
                  <td>
                    <span className={`badge ${c.is_active ? 'badge-success' : 'badge-danger'}`}>
                      {c.is_active ? 'Aktif' : 'Pasif'}
                    </span>
                  </td>
                  <td className="actions">
                    <button className="btn btn-primary btn-sm" onClick={() => openModal(c)}><FaEdit /></button>
                    <button className="btn btn-danger btn-sm" onClick={() => handleDelete(c.id)}><FaTrash /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {modalOpen && (
        <div className="admin-modal-overlay" onClick={() => setModalOpen(false)}>
          <div className="admin-modal" onClick={e => e.stopPropagation()}>
            <div className="admin-modal-header">
              <h2>{editing ? 'Sayaç Düzenle' : 'Yeni Sayaç'}</h2>
              <button className="admin-modal-close" onClick={() => setModalOpen(false)}><FaTimes /></button>
            </div>
            <form onSubmit={handleSubmit} className="admin-form">
              <div className="form-group">
                <label>Ikon</label>
                <select value={form.icon} onChange={e => setForm({...form, icon: e.target.value})}>
                  {ICON_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Değer (Sayı)</label>
                <input type="number" value={form.value} onChange={e => setForm({...form, value: parseInt(e.target.value) || 0})} />
              </div>
              <div className="form-group">
                <label>Sonek</label>
                <input type="text" value={form.suffix} onChange={e => setForm({...form, suffix: e.target.value})} placeholder="+ veya bos" />
              </div>
              <div className="form-group">
                <label>Etiket</label>
                <input type="text" value={form.label} onChange={e => setForm({...form, label: e.target.value})} placeholder="Örn: Tamamlanan Proje" />
              </div>
              <div className="form-group">
                <label>Sıra</label>
                <input type="number" value={form.sort_order} onChange={e => setForm({...form, sort_order: parseInt(e.target.value) || 0})} />
              </div>
              <div className="form-group">
                <label>Durum</label>
                <div className="toggle-switch">
                  <input type="checkbox" checked={form.is_active} onChange={e => setForm({...form, is_active: e.target.checked})} />
                  <span>{form.is_active ? 'Aktif' : 'Pasif'}</span>
                </div>
              </div>
              <div className="form-actions">
                <button type="button" className="btn btn-secondary" onClick={() => setModalOpen(false)}>İptal</button>
                <button type="submit" className="btn btn-primary">{editing ? 'Güncelle' : 'Ekle'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
